// extracted by mini-css-extract-plugin
export default {"avatar":"MbEeTfX","avatar--clickable":"lXKhxx1"};